import { useEffect } from 'react';

const GoogleOAuthCallback = () => {
  useEffect(() => {
    if (window.opener) {
      window.opener.postMessage({ type: 'GOOGLE_OAUTH_SUCCESS' }, window.location.origin);
      window.close();
    }
  }, []);

  return (
    <div style={{ padding: '2rem', textAlign: 'center' }}>
      <h3>Google connected successfully.</h3>
      <p>You can close this window.</p>
    </div>
  );
};

export default GoogleOAuthCallback;